import { useTranslation, Trans } from "next-i18next";
import parse from "html-react-parser";
import Testimonial from "../../../components/v2/mw-carousel/testimonial";
import AgentIntegration from "../../../components/v2/agent-integration";
import Accordion from "../../../components/v2/accordion/accordion";
import ProductResources from "../../../components/v2/product/product-resource";
import ProductHeroSection from "../../../components/v2/common/product-hero";
import FeaturesMonitoring from "../../../components/v2/tabs/features-monitoring";
import ProductTour from "../../../components/v2/product/product-tour";
import {Docker, K8s, Linux, Windows} from "../../../components/v2/icons";
import '../../../styles/scss/_faq-section.module.scss';

export default function MobileRum() {
    const { t } = useTranslation("common");
    const featuresData = t("product.mobile-rum.features.detailedFeatures", { returnObjects: true }) as any[];
    const features = Array.isArray(featuresData) ? featuresData : [];

    const resourceData = t("product.mobile-rum.resources", { returnObjects: true }) as any[];
    const resource = Array.isArray(resourceData) ? resourceData : [];

    const faqsData = t("product.mobile-rum.faq.questions", { returnObjects: true }) as any[];
    const faqs = Array.isArray(faqsData) ? faqsData : [];

    const agentDeployData = t("product.shared.agentDeploy", { returnObjects: true }) as any[];
    const agentDeployArray = Array.isArray(agentDeployData) ? agentDeployData : [];
    const agentDeploy = agentDeployArray.map((agent) => ({
        ...agent,
        icon: agent.key === "kubernetes" ? <K8s/> :
              agent.key === "linux" ? <Linux/> :
              agent.key === "docker" ? <Docker/> :
              agent.key === "windows" ? <Windows/> :
              <span className={"text-gradient"}>450+</span>
    }));

    return (
        <>
            <ProductHeroSection
                title={
                    <h1>
                        <span className={"text-gradient"}>{t("product.mobile-rum.hero.titlePrefix")}</span> {t("product.mobile-rum.hero.titleSuffix")}
                    </h1>
                }
                description={t("product.mobile-rum.hero.description")}
                img={"/images/product/mobile-rum-page.png"} imgMobile={"/images/product/mobile-rum-page-mobile.webp"} preloadImg
                imgAlt={t("product.mobile-rum.hero.imageAlt")}
                hasActions={true}
                tips={t("product.hero.tips")}
            />


            <FeaturesMonitoring
                productFeatures={features}
                title={
                    <h2>
                        <Trans
                            i18nKey="product.mobile-rum.features.title"
                            components={{ highlight: <span className={"text-gradient"} /> }}
                        />
                    </h2>
                }
                tourId={"mobile-rum"}
            />

            <Testimonial/>

            <ProductTour
                tourSrc={"https://app.supademo.com/embed/clzqo6aeu02aj4oytg8x3k1pw?embed_v=2"}
                title={t("product.mobile-rum.productTour.title")}
                tourId={"mobile-rum"}
                description={t("product.mobile-rum.productTour.description")}
            />

            <AgentIntegration agentDeploy={agentDeploy}/>

            <ProductResources resources={resource} title={t("product.shared.resources.title")}/>

            <section className={"faq-section"}>
                <div className={"container"}>
                    <h2>{t("product.mobile-rum.faq.title")}</h2>
                    <p>{t("product.mobile-rum.faq.subtitle")}</p>
                    <div className={"faq-item"}>
                        <Accordion faqs={faqs.map((faq) => ({
                            ...faq,
                            answerPlain: faq.text,
                            text:
                                faq.textHtml != null && faq.textHtml !== ""
                                    ? parse(faq.textHtml)
                                    : <p>{faq.text}</p>
                        }))} showGroups={true}/>
                    </div>
                </div>
            </section>

        </>
    )
}